import { _ as t } from "../internals/export.js";
import { t as r } from "../internals/to-object.js";
import { l as o } from "../internals/length-of-array-like.js";
import { t as a } from "../internals/to-integer-or-infinity.js";
import { a as i } from "../internals/add-to-unscopables.js";
t({
  target: "Array",
  proto: !0
}, {
  at: function at(t) {
    var i = r(this),
      n = o(i),
      s = a(t),
      e = s >= 0 ? s : n + s;
    return e < 0 || e >= n ? void 0 : i[e];
  }
}), i("at");